import React, { Component } from "react";
import Head from "next/head";
import PropTypes from "prop-types";
import NProgress from "components/NProgress";
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import ReactPixel from 'react-facebook-pixel';
// import TagManager from 'react-gtm-module';
import { clearInnityAds, loadInnityRoller, clearInnityAdsInlineVideo, innityInlineVideo, innityInline3d  } from '../utils/innity';

// const tagManagerArgs = {
//     gtmId: 'GTM-WCJSTPT',
// }

const styles = theme => ({
    root: {
        flexGrow: 1,
    },
    paper: {
        padding: theme.spacing.unit * 2,
        color: theme.palette.text.secondary,
        [theme.breakpoints.up('sm')]: {
            margin: '50px 0px'
        },
    },
    innityAd: {
        padding : 60,
        textAlign: 'center'
    }
});

class AdInnityAdPageTwo extends Component {
    constructor(props){
        super(props);
        this.state = {
            ssrDone: false,
        };
    }
    
    render() {
        const { classes } = this.props;
        return(
          <div>
            <Head>
              <title>Ads Test</title>
            </Head>
            <NProgress />
            <div className={classes.root}>
              <Grid
                container
                direction="row"
                justify="center"
                alignItems="center"
              >
                <Grid item xs={12} sm={10} md={8}>
                  <Paper className={classes.paper}>
                    <Typography>
                                    More than 20 films will be screened from a variety of countries including Belgium, Czech Republic, Denmark, Hungary, Norway, Switzerland, the United Kingdom, and Bulgaria.
                    </Typography>
                    <Typography>
                                    Makers Market is back at the Karaweik Gardens to bring you the finest hand-made goods, all locally made. This is the seventh time the event has been run, with the last being on June 2.
                    </Typography>
                      <div id="innity-ads-inline-3d" className='ads-style' style={{textAlign : 'center'}} />
                    <Typography>
                                    For those of you familiar with the Makers Market, you know you will be browsing for beautiful handmade arts and crafts, visiting all the food stalls and jamming to local tunes.
                    </Typography>
                    {/*<div id="innity-ads-inline-video" className='ads-style' style={{textAlign : 'center'}} />*/}
                  </Paper>
                </Grid>
              </Grid>
            </div>
            {/*<div className={classes.innityAd} id="innity-ads-roller" />*/}
          </div>
        )
    }
    componentDidMount () {
        // ************ start facebook pixel ***********

        if (!window.PX_INITIALIZED) {
            const advancedMatching = { em: '' }; // optional, more info: https://developers.facebook.com/docs/facebook-pixel/pixel-with-ads/conversion-tracking#advanced_match
            const options = {
                autoConfig: true, 	// set pixel's autoConfig
                debug: false, 		// enable logs
            };
            ReactPixel.init('548709379041005', advancedMatching, options);
            // ReactPixel.init('355678948310337', advancedMatching, options);
            window.PX_INITIALIZED = true
        }
        // ReactPixel.pageView(); 					// For tracking page view
        //  ReactPixel.track( event, data ) 		// For tracking default events, more info about events and data https://developers.facebook.com/docs/ads-for-websites/pixel-events/v2.9
        //  ReactPixel.trackCustom( event, data ) 	// For tracking custom events
        // ************ end facebook pixel ***********
        this.setState({
            ssrDone: true,
        });
        // clearInnityAdsInlineVideo();
        // innityInlineVideo();
        // clearInnityAds();
        // loadInnityRoller();
        innityInline3d();
    }

    componentDidUpdate(previousProps, previousState){
        // TagManager.dataLayer(tagManagerArgs)

        clearInnityAds();
        // loadInnityRoller();
        // clearInnityAdsInlineVideo();
        // innityInlineVideo();
        innityInline3d();
    }
}

export default withStyles(styles)(AdInnityAdPageTwo);
